import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Carousel.module.scss";
import PathContext from "../../context/path";
import StatesContext from "../../context/states";
const Carousel = (props) => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const [allImgs, setAllImgs] = useState(0);
  const [currentImg, setCurrentImg] = useState(0);
  const refImgs = useRef([]);
  const { data } = props;
  const { hrefVacancy, endpoint } = states;
  const switchImg = (number) => {
    if (currentImg + number >= 0 && currentImg + number < allImgs) {
      setCurrentImg(currentImg + number);
    }
  }
  useEffect(() => {
    setAllImgs(data.length);
  }, [data.length]);
  useEffect(() => {
    refImgs.current.forEach(element => {
      element.classList.remove(styles.active);
    });
    if (refImgs.current[currentImg] !== undefined) {
      refImgs.current[currentImg].classList.add(styles.active);
    }
  }, [currentImg]);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.imgs}>
          {
            data !== null && data.length > 0 ?
              data.map((element, index) => {
                return <div className={styles.img} key={`img-${index}`} ref={(item) => refImgs.current[index] = item}>
                  <img src={`${endpoint}${element.image.url}`} alt="" />
                </div>
              })
              : null
          }
        </div>
        <div className={styles.navs}>
          <div className={styles.nav} onClick={() => { switchImg(-1) }}>
            <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.7041 20.6289L1.55595 10.9993L9.7041 1.36965" stroke="#003333" strokeWidth="1.5" />
            </svg>

          </div>
          <div className={styles.count}>{currentImg + 1} из {allImgs}</div>
          <div className={styles.nav} onClick={() => { switchImg(1) }}>
            <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.29688 20.6289L9.44502 10.9993L1.29688 1.36965" stroke="#003333" strokeWidth="1.5" />
            </svg>

          </div>
        </div>
      </div>
    </>
  );

}

export default Carousel;
